import { useSearchFragmentData } from "@radarly/core/fragment/use-cases";
import { AIFragment, SearchFragment } from "@radarly/models/search";
import { usePrevious } from "./usePrevious";

export function useWidgetFragmentData<F extends SearchFragment | AIFragment>(
  project: number,
  fragment: F,
  mutualized: boolean = true
) {
  const { loading, data, isError } = useSearchFragmentData(
    project,
    fragment,
    mutualized
  );
  const previousData = usePrevious(data, loading);
  return {
    loading,
    data: previousData,
    isError,
  };
}
